import React from 'react';

const MenuContainer = ({ children }) => {
  return <div className="container">{children}</div>;
};

export default MenuContainer;
